/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Cargo_Apply_Diff_To_RelatedInputs */

const en_cargo_apply_diff_to_related = /** @type {(inputs: Cargo_Apply_Diff_To_RelatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apply diff to all ${i?.count} related cargos`)
};

const es_cargo_apply_diff_to_related = /** @type {(inputs: Cargo_Apply_Diff_To_RelatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aplicar dif a las ${i?.count} cargas relacionadas`)
};

/**
* | output |
* | --- |
* | "Apply diff to all {count} related cargos" |
*
* @param {Cargo_Apply_Diff_To_RelatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_apply_diff_to_related = /** @type {((inputs: Cargo_Apply_Diff_To_RelatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Apply_Diff_To_RelatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_apply_diff_to_related(inputs)
	return es_cargo_apply_diff_to_related(inputs)
});